module.exports = __webpack_public_path__ + "img/ax.03c8eb88.svg";